import { readSelectionSnapshot } from "./InspectionSelectionSync";

interface SelectionReceiverOptions {
  context: () => { request: any; id: number; kbn: number };
  apply: (snapshot: any) => void;
  onError: () => void;
  ready?: () => boolean;
  beforeCourseRefresh?: () => Promise<any>;
}

// 通知とAPI応答の順序制御を画面間で共通化する。
export class SelectionNotificationReceiver {
  disposed = false;
  private pending = false;
  private refreshing = false;
  private version = 0;
  private snapshot: any = null;
  private needsCourseRefresh = false;
  private preparingCourse = false;

  constructor(private options: SelectionReceiverOptions) {}

  dispose() {
    this.disposed = true;
    this.snapshot = null;
    this.pending = false;
  }

  receive(body?: any, courseNotification = false): Promise<void> {
    if (this.disposed) { return Promise.resolve(); }
    this.version++;
    this.needsCourseRefresh = this.needsCourseRefresh || courseNotification;
    this.snapshot = readSelectionSnapshot(body, this.options.context().kbn);
    this.pending = !this.snapshot;
    return this.resume();
  }

  async resume(): Promise<void> {
    if (this.disposed || (this.options.ready && !this.options.ready())) { return; }
    // 保存結果は進行中のGETを待たず反映する。旧応答はversionで破棄する。
    if (this.snapshot && !this.needsCourseRefresh && !this.preparingCourse) {
      const snapshot = this.snapshot;
      this.snapshot = null;
      this.options.apply(snapshot);
    }
    if (this.refreshing) { return; }
    this.refreshing = true;
    try {
      while (!this.disposed && (this.pending || this.snapshot || this.needsCourseRefresh)) {
        const version = this.version;
        if (this.needsCourseRefresh) {
          this.needsCourseRefresh = false;
          this.preparingCourse = true;
          try {
            if (this.options.beforeCourseRefresh) { await this.options.beforeCourseRefresh(); }
          } finally {
            this.preparingCourse = false;
          }
          if (this.disposed) { return; }
          if (version !== this.version) { continue; }
        }
        let snapshot = this.snapshot;
        this.snapshot = null;
        if (!snapshot) {
          this.pending = false;
          const { request, id, kbn } = this.options.context();
          const [detail, option, coupon] = await Promise.all([
            request.getInsectionDetail(id, kbn), request.getOption(id, kbn), request.getCoupon(id, kbn)
          ]);
          if (this.disposed) { return; }
          if (version !== this.version) { continue; }
          if (!detail || !option || !coupon) { throw new Error("Missing selection data"); }
          snapshot = { detail, option, coupon };
        }
        this.options.apply(snapshot);
      }
    } catch (err) {
      if (!this.disposed) { this.options.onError(); }
    } finally {
      this.refreshing = false;
    }
  }
}
